import { ReactNode, FunctionComponent } from "react";
import styled from "@emotion/styled";

interface Props {
  children: ReactNode;
}

export const Layout: FunctionComponent<Props> = ({ children }) => {
  return (
    <LayoutWrapper>
      <BackGroundImage
        src={process.env.PUBLIC_URL + "/images/blackhole.jpeg"}
      />
      <main>{children}</main>
    </LayoutWrapper>
  );
};

const LayoutWrapper = styled.div`
  overflow-x: hidden;

  main {
    position: absolute;
    z-index: 1;

    width: 100vw;
    height: 100vh;

    display: flex;
    flex: 1;
  }
`;
const BackGroundImage = styled.img`
  position: absolute;
  object-fit: cover;
  width: 100vw;
  height: 100vh;
  z-index: 0;
  pointer-events: none;
`;
